module.exports = __webpack_public_path__ + "media/faqSection/down-bba6430f.png";